<template>
  <v-dialog v-model="dialog" @click:outside="cancel" no-click-animation width="800">
    <v-stepper v-if="dialog" v-model="st">
      <v-stepper-header>
        <v-stepper-step :step="1" :complete="st > 1">{{ $t('welcome') }}</v-stepper-step>
        <v-divider />
        <v-stepper-step :step="2" :complete="st > 2">{{ $t('type') }}</v-stepper-step>
        <v-divider />
        <v-stepper-step :step="3">{{ $t('new') }}</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1">
          <u-welcome @next="st++" @cancel="cancel" />
        </v-stepper-content>
        <v-stepper-content :step="2">
          <u-type @next="st++" @prev="st--" @cancel="cancel" />
        </v-stepper-content>
        <v-stepper-content :step="3">
          <u-new :namespaces="deployments" @prev="st--" @cancel="cancel" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import DeployNewComponent from '@/components/new-deployment/New.vue'
import DeployTypeComponent from '@/components/new-deployment/Type.vue'
import DeployWelcomeComponent from '@/components/new-deployment/Welcome.vue'

export default {
  data () {
    return {
      dialog: false,
      st: 1
    }
  },
  props: {
    deployments: Array,
    open: Boolean
  },
  watch: {
    open (newVal) {
      if (newVal) {
        this.st = 1
      }
      this.dialog = newVal
    }
  },
  methods: {
    cancel () {
      this.st = 1
      this.dialog = false
      this.$emit('close')
    }
  },
  components: {
    'u-new': DeployNewComponent,
    'u-type': DeployTypeComponent,
    'u-welcome': DeployWelcomeComponent
  }
}
</script>

<i18n>
{
  "en": {
    "new": "New Deployment",
    "type": "Deployment Type",
    "welcome": "Goal"
  }
}
</i18n>

<style lang="scss">
.v-stepper {
  border-radius: 0;
}

.v-stepper__header {
  margin-bottom: 5px;
}

.v-stepper__items {
  &, .v-stepper__wrapper {
    overflow: visible;
  }
}

.v-stepper__content {
  padding: 0;
}

@media (max-height: 730px) {
  .v-stepper__header {
    display: none;
  }
}
</style>
